window.onload = function() {
  let domBody = document.body;
  let header = document.getElementById('js-header');
  let modalBtn = document.getElementById('js-global_modalBtn');
  let modalWrap = document.getElementById('js-modal_wrap');
  let modalCloseBtn = document.getElementById('js-modal_close');
  let modalBk = document.getElementById('js-modal_bk');
  modalBtn.addEventListener('click', () =>{
    modalOpen();
  });
  modalCloseBtn.addEventListener('click', () =>{
    modalClose();
  });
  const modalOpen = () => {
    domBody.classList.add('show');
    modalWrap.classList.add('show');
    modalBk.classList.add('show');
    header.classList.add('head_modal');
  };
  const modalClose = () => {
    domBody.classList.remove('show');
    modalWrap.classList.remove('show');
    modalBk.classList.remove('show');
    header.classList.remove('head_modal');
  };
}
window.addEventListener('DOMContentLoaded', () => {
  const anchorLinks = document.querySelectorAll('a[href^="#"]');
  const anchorLinksArr = Array.prototype.slice.call(anchorLinks);
  anchorLinksArr.forEach(link => {
    link.addEventListener('click', e => {
      e.preventDefault();
      const targetId = link.hash;
      const targetElement = document.querySelector(targetId);
      const targetOffsetTop = window.pageYOffset + targetElement.getBoundingClientRect().top;
      window.scrollTo({
        top: targetOffsetTop,
        behavior: "smooth"
      });
    });
  });
});
document.addEventListener('DOMContentLoaded', function() {
  var observer = lozad('.lozad', {
    rootMargin: '0% 0% 2% 0%' 
  })
observer.observe()
});



(function() {
  const target     = document.getElementById('js-header'),
        height     = 75,
        select_page = document.getElementById('js-select_pager'),
        option_page = document.querySelectorAll("#js-select_pager option"),
        dataTagId = document.querySelectorAll(".js-tag_link"),
        pagetop_fix = document.getElementById('js-pagetop_fix');
  let offset       = 0,
      lastPosition = 0,
      ticking      = false;
  function onScroll() {
    if (lastPosition > height) {
      if (lastPosition > offset) {
        target.classList.add('head-none');
      }else {
          target.classList.remove('head-none');
          target.classList.add('head-touka');
          if(lastPosition < 100){
            target.classList.remove('head-touka');
          }
      }
      offset = lastPosition;
    }
    if(lastPosition > 400){
      pagetop_fix.classList.add('show');
    }else{
      pagetop_fix.classList.remove('show');
    }
  }
  window.addEventListener('scroll', function(e) {
    lastPosition = window.scrollY;
    if (!ticking) {
      window.requestAnimationFrame(function() {
        onScroll(lastPosition);
        ticking = false;
      });
      ticking = true;
    }
  });
  if(select_page){
    select_page.addEventListener('change', function(e) {
      let indexNo =  this.selectedIndex;
      let indexVal = option_page[ indexNo ].value;
      window.location.href = indexVal;
    });
  }
  if(dataTagId){
    dataTagId.forEach(function(item,index){
      item.onclick = function(a){
        a.preventDefault();
        let tagLink = this.dataset.taglink;
        window.location.href = tagLink;
      }
      item.addEventListener("mouseover", function( b ) {
        b.preventDefault();
        item.classList.add('show');
      });

      item.addEventListener("mouseleave", function(c) {
        c.preventDefault();
        item.classList.remove('show');
      });

    });

  }
})();